module.exports = "https://cdn01.riselinkedu.com/assets/images/share.71b6f75.png";